
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class QuantumFoamEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const count = Math.floor(100 * (config.parallaxComplexity || 1.0));
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.3 / (layerIndex + 1);
            for (let i = 0; i < count; i++) {
                const rx = (this.pseudoRandom(i + Math.floor(time * 15)) - 0.5) * width * 3;
                const ry = (this.pseudoRandom(i + 100 + Math.floor(time * 15)) - 0.5) * height * 3;
                const r = (2 + this.pseudoRandom(i) * 10) * scale;
                
                ctx.beginPath();
                ctx.arc(rx, ry, r, 0, Math.PI * 2);
                ctx.stroke();
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
